var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trailing icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.9982 12.917C9.88853 12.9176 9.77981 12.8966 9.67828 12.8551C9.57675 12.8137 9.4844 12.7526 9.40653 12.6753L6.0732 9.34198C5.9955 9.26428 5.93387 9.17204 5.89182 9.07052C5.84977 8.96901 5.82813 8.8602 5.82812 8.75032C5.82812 8.64043 5.84977 8.53163 5.89182 8.43011C5.93387 8.32859 5.9955 8.23635 6.0732 8.15865C6.1509 8.08095 6.24314 8.01932 6.34466 7.97727C6.44618 7.93522 6.55499 7.91357 6.66487 7.91357C6.77475 7.91357 6.88356 7.93522 6.98508 7.97727C7.08659 8.01932 7.17884 8.08095 7.25653 8.15865L9.9982 10.917L12.7482 8.26698C12.8249 8.18174 12.9183 8.11323 13.0226 8.06575C13.127 8.01826 13.24 7.99281 13.3546 7.99099C13.4692 7.98918 13.583 8.01103 13.6888 8.05519C13.7946 8.09935 13.8902 8.16486 13.9695 8.24764C14.0488 8.33041 14.1102 8.42865 14.1498 8.53623C14.1894 8.64381 14.2064 8.75841 14.1997 8.87285C14.193 8.9873 14.1628 9.09913 14.1109 9.20136C14.059 9.30359 13.9866 9.39402 13.8982 9.46698L10.5649 12.6837C10.4125 12.8306 10.2099 12.914 9.9982 12.917Z",
    fill: "#8E97A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.10c73e372ec1e6791fb85ecd75bf5639.svg";
export { ForwardRef as ReactComponent };